import React from "react";

function FGDateHeader({ date, count, isExpanded, isActive, onToggle, hasIssue }) {
  // We can detect if we're on a small screen for inline adjustments
  const isMobile = window.innerWidth <= 768;

  return (
    <div 
      className={`date-header-wrapper ${isActive ? "active-node" : ""}`} 
      onClick={onToggle}
      style={{
        display: "flex",
        alignItems: "center",
        padding: isMobile ? "12px 14px" : "8px 12px", // Larger tap area for mobile
        minHeight: isMobile ? "48px" : "auto",        // Standard mobile hit target
        cursor: "pointer",
        userSelect: "none",
        transition: "all 0.2s ease"
      }}
    >
      <div 
        className="date-header-content" 
        style={{ 
          display: "flex", 
          width: "100%", 
          justifyContent: "space-between", 
          alignItems: "center" 
        }}
      >
        <div 
          className="date-header-left" 
          style={{ 
            display: "flex", 
            alignItems: "center", 
            gap: "1px",
            overflow: "hidden",
            flex: 1
          }}
        >
          <span 
            className={`date-header-icon ${isExpanded ? "rotated" : ""}`}
            style={{
              transition: "transform 0.2s ease",
              display: "inline-block",
              transform: isExpanded ? "rotate(90deg)" : "rotate(0deg)",
              fontSize: isMobile ? "12px" : "10px"
            }}
          >
            ▶
          </span>
          
          <span 
            className="date-header-label"
            style={{
              fontSize: isMobile ? "14px" : "11px",
              fontWeight: "600",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "flex",
              alignItems: "center"
            }}
          >
            {date}
            {hasIssue && (
                <span 
                  className="date-header-warning-badge"
                  style={{ 
                    color: "#ef4444", 
                    fontSize: isMobile ? "1.2rem" : "1rem",
                    flexShrink: 0,    // 🔥 CRITICAL: Prevents CSS from hiding or squishing this icon
                    display: "inline-block",
                    lineHeight: 1
                  }} 
                  title="Contains items with open issues"
                >
                ⚠
              </span>
            )}
          </span>
        </div>

        <div className="date-header-right" style={{ marginLeft: "10px" }}>
          <span 
            className="date-count-badge"
            style={{
              backgroundColor: "#1976d2",
              color: "white",
              padding: "2px 10px",
              borderRadius: "12px",
              fontSize: "0.75rem",
              fontWeight: "700",
              minWidth: "24px",
              textAlign: "center",
              display: "inline-block"
            }}
          >
            {count}
          </span>
        </div>
      </div>
    </div>
  );
}

export default FGDateHeader;